import { Box } from '@mui/material'
import { PlanLabel } from '../types'
import { Stack } from '@dtx-company/design-system/src'
import Image from 'next/image'
import React from 'react'

interface PlanTileImageProps {
  hovered: boolean
  planName: PlanLabel
  planImageSrc?: string
  isCompare?: boolean
}

export const PlanTileImage: React.FC<PlanTileImageProps> = ({
  hovered,
  planImageSrc = '',
  planName,
  isCompare
}) => {
  return (
    <Stack
      direction="column"
      sx={theme => ({
        boxShadow: hovered ? 2 : 'none',
        height: {
          xs: theme.spacing(38),
          sm: isCompare ? theme.spacing(39) : theme.spacing(50),
          md: theme.spacing(53),
          lg: theme.spacing(53)
        },
        minWidth: {
          xs: theme.spacing(38),
          sm: isCompare ? '50%' : 'unset',
          md: '50%',
          lg: 'unset'
        }
      })}
    >
      <Box
        sx={{
          height: '100%',
          width: '100%',
          flexShrink: 0,
          overflow: 'hidden',
          position: 'relative',
          backgroundColor: 'tertiary.dark'
        }}
      >
        <Image
          src={planImageSrc}
          alt={planName}
          fill
          style={{ objectFit: 'cover', objectPosition: !isCompare ? 'bottom' : 'center' }}
        />
      </Box>
    </Stack>
  )
}
